import { render, staticRenderFns } from "./RedeemManagementDetailsScreen.vue?vue&type=template&id=51a2ad78&scoped=true&"
import script from "./RedeemManagementDetailsScreen.vue?vue&type=script&lang=js&"
export * from "./RedeemManagementDetailsScreen.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51a2ad78",
  null
  
)

export default component.exports